import React, {PureComponent} from "react";
import {MfaApplications} from "../util/mfa_applications";
import {
    Button,
    ButtonGroup,
    ContextualBanner,
    Dropdown,
    FormGroup,
    Heading,
    Loader,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Paper,
    Text
} from "@hawkins/components";
import {getUser, getUserFactors, restartOktaEnrollment, setUserMfaApplication} from "../api/mgmt";
import {GetUserFactorsResponse, UserFactor} from "../api/types";
import {ButtonRenderer, Table, TextRenderer, TypeColumn} from "@hawkins/table";
import {IconEye} from "@hawkins/icons";

interface Props {
    userName: string
    domain: string
    mfaApplications: MfaApplications
}

interface State {
    loading?: boolean
    saving?: boolean
    restartLoading?: boolean
    mfaApplicationId?: string
    error?: Error
    getUserFactorsResponse?: GetUserFactorsResponse;
    showFactorProfile?: UserFactor;
}

export default class EditUser extends PureComponent<Props, State> {
    state: State = {}

    componentDidMount() {
        this.refresh();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps.userName !== this.props.userName || prevProps.domain !== this.props.domain) {
            this.refresh();
        }
    }

    private refresh() {
        this.setState({loading: true, getUserFactorsResponse: undefined, showFactorProfile: undefined});

        getUser({userName: this.props.userName, domain: this.props.domain}).then(user => {
            this.setState({loading: false, mfaApplicationId: user.user.mfaApplicationId});
        }).catch(e => {
            this.setState({loading: false, error: e});
        });

        getUserFactors({userName: this.props.userName, domain: this.props.domain}).then(response => {
            this.setState({getUserFactorsResponse: response});
        }).catch(e => {
            this.setState({error: e});
        });
    }

    private save() {
        if (!this.state.mfaApplicationId) {
            return;
        }
        this.setState({saving: true});
        setUserMfaApplication({userName: this.props.userName, domain: this.props.domain, mfaApplicationId: this.state.mfaApplicationId}).then(() => {
            this.setState({saving: false});
        }).catch(e => {
            this.setState({saving: false, error: e});
        })
    }

    private restartOktaEnrollment() {
        this.setState({restartLoading: true});
        restartOktaEnrollment({userName: this.props.userName, domain: this.props.domain}).then(() => {
            this.setState({restartLoading: false});
        }).catch(e => {
            this.setState({restartLoading: false, error: e});
        })
    }

    render() {

        let userIsOnOkta = false;
        const options: Array<{label: string, value: string}> = [];
        for (let app of this.props.mfaApplications.getMfaApplications()) {
            let opt = {label: `${app.name} (${app.description})`, value: app.id};
            options.push(opt);

            if (this.state.mfaApplicationId === app.id && app.type === 'OKTA') {
                userIsOnOkta = true;
            }
        }

        const factorColumns: TypeColumn[] = [
            { flex: 2, header: 'Factor Type', name: 'factorType' },
            { flex: 2, header: 'Provider', name: 'provider' },
            { flex: 2, header: 'Status', name: 'status' },
            {
                flex: 3, header: 'Created', name: 'created', type: 'date',
                render: TextRenderer<number>({text: ({value}) => new Date(value*1000).toISOString()})
            },
            {
                flex: 4, header: 'Name', name: 'profile',
                render: TextRenderer<any>({text: ({value}) => {
                    return value.email || value.authenticatorName || value.name || '';
                }})
            },
            {
                flex: 1, header: 'View Details', name: 'profile',
                render: ButtonRenderer<any, UserFactor>({
                    compact: true, icon: IconEye, variant: 'icon', buttonProps: { 'aria-label': 'view' }, text: '',
                    onClick: ({data, event, value}) => this.setState({showFactorProfile: data})
                })
            }
        ];
        const factors = this.state.getUserFactorsResponse?.factors || [];

        return <React.Fragment>
            <Modal
                onClose={() => this.setState({showFactorProfile: undefined})}
                open={!!this.state.showFactorProfile}
            >
                <ModalHeader compact title="View User Factor" />
                <ModalBody>
                    <Text variant="body">
                        <pre>{JSON.stringify(this.state.showFactorProfile?.profile, null, 3)}</pre>
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup justifyContent="flex-end">
                        <Button onClick={() => this.setState({showFactorProfile: undefined})} variant="secondary">
                            Close
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
            <Paper>
                <Heading>{this.props.userName} ({this.props.domain})</Heading>


                {!this.state.error ? null : <ContextualBanner variant="error" title="Error" text={this.state.error.message} />}
                {this.state.loading ? <Loader variant="linear" /> : null}
                {this.state.loading ? null : <Paper elevation={1} style={{marginTop: '1em'}}>
                    <FormGroup>
                        <FormGroup orientation="horizontal">
                            <Dropdown label="MFA Application" options={options} rawValue={this.state.mfaApplicationId} onChange={newVal => this.setState({mfaApplicationId: newVal?.value})} />
                        </FormGroup>
                        <FormGroup orientation="horizontal">
                            <Button disabled={!this.state.mfaApplicationId} executing={this.state.saving} onClick={() => this.save()}>Save</Button>
                            <Button disabled={!this.state.mfaApplicationId || userIsOnOkta} variant="secondary" executing={this.state.restartLoading} onClick={() => this.restartOktaEnrollment()}>Restart Okta Enrollment</Button>
                        </FormGroup>
                    </FormGroup>
                </Paper>}

                <Paper elevation={1} style={{marginTop: '1em'}}>
                    <Heading>Enrolled Factors</Heading>
                    <Table
                        columns={factorColumns}
                        dataSource={factors}
                        //rowHeight="compact"
                        showColumnMenuTool={false}
                        loading={!this.state.getUserFactorsResponse}
                        style={{ width: '100%', height: '400px' }} />
                </Paper>
            </Paper>
        </React.Fragment>
    }
}
